import React from 'react';
import PropTypes from 'prop-types';
import { BOX_TYPES } from '../constants';
import { useSelector } from 'react-redux';
import { PROGRAM_TYPES } from 'Store/constants/horseRacing';
import { oddFormatter } from 'Utils/decimalFormatter';
import EnvironmentManager from 'Utils/environmentManager';
import { useHRBetslipSystem } from 'Utils/hooks/useHRBetslipSystem';

const SelectedLegsList = ({ selectedLegs, legNumbers, isMobile, legsCounts, betType, isBetWithComma }) => {
  const programType = useSelector(state => state.horseRacing.allHippodromes.programType);
  const betSlip = useSelector(state => state.horseRacing.betSlip);
  const { combinedHorses, verify, footerData } = betSlip;
  const { system } = footerData;
  const verifyData = verify?.data?.body || {};
  const { systemSelected } = useHRBetslipSystem();

  const renderSystem = () => {
    if (systemSelected && isMobile) return <div className="mobile-system-view">Sistem: <span>{ system?.join('-') }</span></div>;
  };

  return programType === PROGRAM_TYPES.JOINT ? <div className="betslip-selected-horses">
    { isMobile && <span className="title">Seçimler: </span> } { legNumbers?.map((leg, index) => <div key={ leg }>
      { selectedLegs[leg]?.map((horse, index) => horse.horseNo.toString()).length > 0
      && <span className="list-item" key={ leg }>
        { !isBetWithComma && (selectedLegs[leg].filter(item => item.isRunning === true).length === legsCounts[betType === BOX_TYPES.HORSE ? 0 : index]) ? 'H' : selectedLegs[leg]?.map(horse => horse.horseNo.toString()).join(',') }
      </span> }
      { legNumbers.length !== index + 1 && <span className="separator">/</span> }</div>) }
  </div> : <div className="betslip-fix-selected-horse">
    { (() => {
      if (!(combinedHorses?.length > 0)) {
        return (
          <>
            <div>Seçim: <span>-</span></div>
            <div>Oran: <span>-</span></div>
          </>
        );
      }

      const odds = combinedHorses.some(h => h?.horse?.propositionInfo?.spbah)
        ? 'K.O'
        : (() => {
          if (verify?.error) {
            return oddFormatter(verify?.error?.extras?.fixedOddVerifyResponse?.totalOdd) || '-';
          }

          if (verifyData?.fixedOddVerifyResponse?.totalOdd) {
            return oddFormatter(verifyData?.fixedOddVerifyResponse?.totalOdd);
          }

          return '-';
        })();

      if (combinedHorses.length === 1) {
        const horse = combinedHorses[0]?.horse;
        return (
          <>
            { horse?.uniqId ? <div>Bahis:&nbsp;<span>{ horse?.horseNo }. { horse?.name }</span></div>
              : <div>Seçim: <span>{ combinedHorses[0]?.horse?.propositionInfo.horseNumbers.replace('-', '/') }</span></div> }

            <div>Oran: <span>{ odds }</span></div>
          </>
        );
      }


      const limit = EnvironmentManager.getMessageText({ key: 'v1.general.parlay_odd_limit_count' });
      return (
        <>
          <div><span>{ combinedHorses.length } Bahis</span>&nbsp;Ekledin&nbsp;<span>{ `(${combinedHorses.length}/${limit})` }</span>&nbsp;{ renderSystem() }
          </div>
          <div>Oran: <span>{ odds }</span></div>
        </>
      );
    })() }
  </div>
  ;
};

SelectedLegsList.propTypes = {
  selectedLegs: PropTypes.object,
  legNumbers: PropTypes.object,
  legsCounts: PropTypes.object,
  isMobile: PropTypes.bool,
  isBetWithComma: PropTypes.bool,
  betType: PropTypes.string
};
export default SelectedLegsList;
